import { bus } from '../engine/EventBus';
import { save } from '../engine/SaveSystem';
import { FURNITURE_CATALOG, findFurniture } from '../data/furniture';

export class BuildPalette {
  readonly el: HTMLElement;
  onSelect?: (id: string) => void;
  onExit?: () => void;
  private currentId: string | null = null;

  constructor(root: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'build-palette hidden';
    root.appendChild(this.el);
    bus.on('furniture:placed', () => this.render());
    bus.on('shop:purchase', () => this.render());
  }

  show(): void {
    this.render();
    this.el.classList.remove('hidden');
  }
  hide(): void { this.el.classList.add('hidden'); this.currentId = null; }

  private render(): void {
    const owned = save.data.unlockedFurniture
      .map((id) => findFurniture(id))
      .filter((d): d is NonNullable<typeof d> => !!d);
    this.el.innerHTML = owned.map((f) => (
      `<div class="build-item ${this.currentId === f.id ? 'active' : ''}" data-id="${f.id}">
        <div class="thumb">${f.emoji}</div>
        <div>${f.label}</div>
      </div>`
    )).join('') + `<div class="build-item" data-action="exit" style="background:#ffd7e8">
        <div class="thumb">✕</div><div>Exit</div>
      </div>`;

    this.el.querySelectorAll('.build-item').forEach((it) => {
      it.addEventListener('click', () => {
        const el = it as HTMLElement;
        if (el.dataset.action === 'exit') {
          this.onExit?.();
          return;
        }
        const id = el.dataset.id!;
        this.currentId = id;
        this.onSelect?.(id);
        this.render();
      });
    });

    // Also show unowned count as tooltip — easy future enhancement
    const totalUnlockable = FURNITURE_CATALOG.length;
    if (owned.length < totalUnlockable) {
      const note = document.createElement('div');
      note.className = 'build-item';
      note.style.background = 'transparent';
      note.style.fontSize = '10px';
      note.innerHTML = `<div class="thumb">🛒</div><div>${totalUnlockable - owned.length} more at shop</div>`;
      this.el.insertBefore(note, this.el.lastElementChild);
    }
  }
}
